import React from 'react';
import { FormControl, FormLabel, Flex, Text } from '@chakra-ui/react';
import Select, { components } from 'react-select';
import { Field } from 'formik';

const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      <Flex
        direction='column'
        gap={1}>
        <Flex gap={2}>
          <Text fontWeight='bold'>{props.data.titleLabel}</Text>

        </Flex>
        
        <Text
          fontSize='sm'
          fontWeight='semibold'
          color='gray.600'>
          {props.data.subLabel}
        </Text>

        <Text
          fontSize='sm'
          color='gray.600'>
          {props.data.bodyLabel}
        </Text>
      </Flex>
    </components.Option>
  );
};

const MultiLineSelectField = ({
  required = false,
  disabled = false,
  label,
  name,
  options,
  ...rest
}) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused
        ? 'blue'
        : state.isDisabled
          ? base.borderColor
          : state.selectProps.error
            ? 'red'
            : base.borderColor,
      width: '100%',
    }),
    container: (base) => ({
      ...base,
      width: '100%',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'skyblue' : provided.backgroundColor,
    }),
  };

  return (
    <FormControl
      mt={6}
      isRequired={required}
      width='100%'>
      <FormLabel
        fontSize='md'
        pl='2'
        fontWeight='500'>
        {label}
      </FormLabel>
      <Flex
        alignItems='center'
        mt={-1}
        width='100%'>
        <Field name={name}>
          {({ field, form, meta }) => (
            <Flex
              direction='column'
              width='100%'>
              {/* {console.log('here is your meta', meta)} */}
              <Select
                name={field.name}
                value={
                  options
                    ? options.find((option) => option.value === field.value)
                    : ''
                }
                options={options}
                isDisabled={disabled}
                onChange={(option) => form.setFieldValue(name, option.value)}
                onBlur={() => form.setFieldTouched(name, true)} // Mark field as touched on blur
                getOptionLabel={(option) => option.titleLabel}
                getOptionValue={(option) => option.value}
                components={{ Option: CustomOption }}
                styles={customStyles}
                error={meta.touched && meta.error}
                {...rest}
              />
              {meta.touched && meta.error && (
                <Flex
                  color='red.600'
                  fontSize='sm'
                  fontWeight='500'
                  pl='2'>
                  <Text>{meta.error}</Text>
                </Flex>
              )}
            </Flex>
          )}
        </Field>
      </Flex>
    </FormControl>
  );
};

export default MultiLineSelectField;
